import script from "./RouteIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteIcon.vue?vue&type=script&setup=true&lang=js"

import "./RouteIcon.vue?vue&type=style&index=0&id=7bb2d437&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb2d437"]])

export default __exports__